import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';

function FloatingCheckoutButton() {
  const navigate = useNavigate();
  const { getTotalItems } = useCart();
  const [isVisible, setIsVisible] = useState(false);

  const cartItemCount = getTotalItems();
  const hasItems = cartItemCount > 0;

  useEffect(() => {
    const offset = 150; // Same offset as scroll-to-top

    const handleScroll = () => {
      if (window.pageYOffset > offset && hasItems) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Check initial state
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasItems]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/checkout');
  };

  // Don't render if no items in cart
  if (!hasItems) return null;

  return (
    <button
      onClick={handleClick}
      aria-label="Go to Checkout"
      style={{
        position: 'fixed',
        bottom: '30px',
        left: '30px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 87, 34, 0.85)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
        zIndex: 999,
        opacity: isVisible ? 1 : 0,
        visibility: isVisible ? 'visible' : 'hidden',
        transform: isVisible ? 'scale(1)' : 'scale(0.8)',
        transition: 'opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease',
      }}
    >
      {/* Shopping cart icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
      </svg>

      {/* Item count badge */}
      <span
        style={{
          position: 'absolute',
          top: '-5px',
          right: '-5px',
          backgroundColor: '#fff',
          color: '#ff5722',
          borderRadius: '50%',
          width: '22px',
          height: '22px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          fontWeight: 'bold',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        {cartItemCount > 99 ? '99+' : cartItemCount}
      </span>
    </button>
  );
}

export default FloatingCheckoutButton;
